export default function DownloadsScreen() {
  return null;
}
